<template>
    <div class="addSeal">
        <div class="per_title">
            <div class="title">添加个人印章</div>
            <!-- <div class="btn">上传图片</div>
             <span>上传的图片需要清晰，图片背景为透明背景</span>
             <div class="lookBtn" @click="testDialogVisible = true">查看示例</div> -->
        </div>


        <el-form ref="login" :rules="rules" :model="dataForm"  >


            <div class="account">
                <div class="acte">用户名：</div>
                <div class="input">
                    <el-input v-model="dataForm.userName"></el-input>
                </div>
            </div>
            <div class="account">
                <div class="acte">手机号：</div>
                <div class="input">
                    <el-input v-model="dataForm.phoneNo"></el-input>
                </div>
            </div>


            <div class="account">
                <div class="acte">印章名称：</div>
                <div class="input">
                    <el-form-item  prop="sealName">
                        <el-select v-model="dataForm.sealName" placeholder="请选择印模" clearable >
                            <el-option v-for="item in sealNameList" :key="item" 
                                :label="item" :value="item">
                            </el-option>
                            <el-option label="自定义" value="-1" style="color:red" ></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>

            <div class="account" v-if="dataForm.sealName=='-1'">
                <div class="acte" style="color:red;font-size:11px;padding-right: 20px;"> 自定义必填</div>
                <div class="input">
                    <el-form-item prop="sealName"  >
                        <el-input v-model="dataForm.sealName2"  placeholder="请输入印章名称" ></el-input>
                    </el-form-item>
                </div>
            </div>


            <div class="account">
                <div class="acte">印章密码：</div>
                <div class="input">
                    <el-form-item prop="sealPassword">
                        <el-input prefix-icon="el-icon-lock" v-model="dataForm.sealPassword"  placeholder="请输入印章密码"
                         clearable show-password> </el-input>
                    </el-form-item>
                </div>
            </div>
            <!-- <div class="account">
                <div class="acte">证书密码、密文：</div>
                <div class="input">
                    <el-form-item prop="pkcs12Password">
                        <el-input prefix-icon="el-icon-lock" v-model="dataForm.pkcs12Password"  placeholder="请输入证书密码"
                         clearable show-password> </el-input>
                    </el-form-item>
                </div>
            </div> -->

            <div class="account">
                <div class="acte">身份证正反面：</div>
                <div class="input" style="display: contents;">
                    <el-form-item  prop="positiveImg">
                        <cm-upload  v-model="dataForm.positiveImg"  ></cm-upload>
                    </el-form-item>
                    <span style="width: 20px;"></span>
                    <el-form-item  prop="reverseImg">
                        <cm-upload  v-model="dataForm.reverseImg"  ></cm-upload>
                    </el-form-item>
                </div>
            </div>

             
            <div class="account">
                <div class="acte">半身照：</div>
                <div class="input" style="display: contents;">
                    <el-form-item  prop="halfPhoto">
                        <cm-upload  v-model="dataForm.halfPhoto"  ></cm-upload>
                    </el-form-item>
                    <span style="width: 20px;"></span>
                    <el-form-item  prop="halfPhoto2">
                        <cm-upload  v-model="dataForm.halfPhoto2"  ></cm-upload>
                    </el-form-item>
                </div>
            </div>

            <div class="account">
                <div class="acte">申请表/委托书：</div>
                <div class="input" style="display: contents;">
                    <el-form-item  prop="instrument">
                        <cm-upload  v-model="dataForm.instrument"  ></cm-upload>
                    </el-form-item>
                    <span style="width: 20px;"></span>
                    <el-form-item  prop="instrument2">
                        <cm-upload  v-model="dataForm.instrument2"  ></cm-upload>
                    </el-form-item>
                </div>
            </div>


            <div class="bus">
                <div class="action">
                    <span>印章印模：</span>
                    <div class="select">
                         <el-form-item  prop="stampId">
                             <el-select v-model="dataForm.stampId" placeholder="请选择印模" clearable @change="getStampId">
                                 <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                                 </el-option>
                             </el-select>
                         </el-form-item>
                        <div class="img"  v-if="dataForm.stampId!=''" >
                            <img :src="'data:image/png;base64,'+ stampImg" v-show="stampImg"/>
                        </div>
                    </div>
                </div>
            </div>
            
            
    
            <div class="Ukey">
                <span style="font-weight: bolder;">是否选择Ukey介质：</span>
                <el-checkbox v-model="dataForm.isUkeyFlag" id="ukeyCheck"></el-checkbox>
                <div class="text">Ukey介质介绍 
                    <span @click="handlCheckZhan">{{isZhanKai?'收起':'展开'}}</span>
                </div>
                <div class="look">（请仔细查看根据您的需要选择）</div>
            </div>
            <div v-show="isZhanKai" class="noText" v-html="content"></div>
    

            <el-form  v-show="dataForm.isUkeyFlag"  ref="ukeyUserForm" :rules="rules2" :model="dataForm"  >
                <div class="account">
                    <div class="acte">收件人：</div>
                    <div class="input">
                        <el-form-item  prop="ukeyUserName">
                            <el-input v-model="dataForm.ukeyUserName"  placeholder="请输入收件人姓名"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="account">
                    <div class="acte">收件人联系电话：</div>
                    <div class="input">
                        <el-form-item  prop="ukeyUserPhone">
                            <el-input v-model="dataForm.ukeyUserPhone"  placeholder="请输入收件人联系电话"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="account">
                    <div class="acte">收件地址：</div>
                    <div class="input">
                        <el-form-item  prop="ukeyUserAddress">
                            <el-input v-model="dataForm.ukeyUserAddress"  placeholder="请输入收件地址"></el-input>
                        </el-form-item>
                    </div>
                </div>

            </el-form>

            

            <div class="regist">
                <el-checkbox v-model="regChecked" id="regCheck"></el-checkbox>
                我已同意<span style="cursor: pointer;" @click="handlJump">《电子签章申请协议》</span>
            </div>
    
    
            <div class="perBtn">
                <div class="btn" @click="handlCheckSubmit">提交</div>
            </div>


        </el-form>

        <el-dialog :visible.sync="agreementDialogVisible" width="50%" center  title="电子签章申请协议" >
            <div>
                <div class="agree_mess" v-html="agreementContent"></div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="agreementDialogVisible = false">取 消</el-button>
              </span>
        </el-dialog>




    </div>
</template>

<script>
    import CmUpload from '@/components/CmUpload' // 上传图片组件引入
    export default {
        components: {   CmUpload },
        data() {
            return {

                dataForm:{
                    addType : '0',
                    applyType : '0',
                    customerType : '1',

                    sealName:'',
                    sealPassword:'',
                    pkcs12Password:'',

                    stampId:'',
                    token: this.$global.token ,
                    userName: this.$global.webData.name ,
                    phoneNo: this.$global.webData.phone ,

                    positiveImg:'',
                    reverseImg:'',
                    halfPhoto:'',
                    halfPhoto2:'',
                    instrument:'',
                    instrument2:'',

                    isUkeyFlag: false , 
                    isUkey: false , 
                    ukeyUserName:'',
                    ukeyUserPhone:'',
                    ukeyUserAddress:'',

                },

                options: [],
                stampImg: '',
                
                content:'',
                isZhanKai:false,
                regChecked: false,  

                agreementDialogVisible:false,
                agreementContent:'',

                rules: {
                    sealName:[{  required: true,  message: '请输入印章名称', trigger: 'blur'  }],
                    stampId:[{  required: true,  message: '请选择印模信息', trigger: 'blur'  }],
                    positiveImg:[{ required: true, message: '请上传身份证正面照', trigger: 'blur' }],
                    reverseImg:[{  required: true, message: '请上传身份证反面照', trigger: 'blur' }],
                    halfPhoto:[{  required: true, message: '请上传半身照', trigger: 'blur' }],
                    //halfPhoto2:[{  required: true, message: '请上传半身照', trigger: 'blur' }],
                    instrument:[{  required: true, message: '请上传申请书照片', trigger: 'blur' }],
                    //instrument2:[{  required: true, message: '请上传申请书照片', trigger: 'blur' }],
                    sealPassword: [
                        {
                            required: true,
                            message: '请输入印文密码',
                            trigger: 'blur'
                        },
                        {
                            min: 6,
                            max: 15,
                            message: '密码长度应大于等于6个字符小于16个字符!',
                            trigger: "blur"
                        },
                        {
                            trigger: 'blur',
                            validator: (rule, value, callback) => {
                                var passwordreg = /(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)/
                                console.log(passwordreg.test(value))
                                if (!passwordreg.test(value)) {
                                    callback(new Error('密码必须由大写字母、小写字母、数字、特殊符号中的2种及以上类型组成!'))
                                } else {
                                    callback()
                                }
                            }
                        },
                    ],
                    
                },
                rules2: {
                    ukeyUserName:[{
                        required: true,
                        message: '请输入收货人姓名',
                        trigger: 'blur'
                    }],
                    ukeyUserPhone:[{
                        required: true,
                        message: '请输入收货人电话号码',
                        trigger: 'blur'
                    }],
                    ukeyUserAddress:[{
                        required: true,
                        message: '请输入收货人详细地址',
                        trigger: 'blur'
                    }]
                },

                sealNameList:[],

            }
        },
        mounted() {
            
            // 获取用户印模列表 
            this.getYinMu();

            // 获取后台维护的印章名称类型
            this.getSealNameList();

            // 获取Ukey使用协议
            this.getUkeyMes();

            if (this.$route.params.id) {
                let sealId = this.$route.params.id
                this.dataForm.id = sealId;
            }else{
                console.log("首次申请个人印章");
            }

        },  
        methods: {
            getSealNameList(){
                // 【API请求】-----获取印模列表
                this.api.getSealNameList().then(res => {
                    this.sealNameList = res.data;
                })
            },          

            handlCheckSubmit() {
                let _this = this;
                
                //选择使用ukey后，对收货人信息进行校验
                
                var aFlag = true;
                _this.$refs.login.validate(valid => {
                    if(valid){
                        if (!_this.isLookXieYi()) {
                            return false;
                        }else  if( _this.dataForm.isUkeyFlag ){
                            _this.$refs.ukeyUserForm.validate(valid => { 
                                if(!valid){
                                    aFlag = false;
                                    return false ;
                                }
                            })
                        }
                        if(aFlag){

                            
                            let param =  this.dataForm;
                            param.isUkey =  this.dataForm.isUkeyFlag?'1':'0'
                            
                            if(this.dataForm.sealName ==='-1'){
                                param.sealName = this.dataForm.sealName2;
                            }
                            
                            if( !this.dataForm.isUkeyFlag ){
                                param.ukeyUserName = '';
                                param.ukeyUserPhone = '';
                                param.ukeyUserAddress = '';
                            }
                            
                            console.log( param )
                            param.pkcs12Password = param.sealPassword;
                            // return;

                            // 对象信息封装转化为  FormData
                            let formData = new FormData();
                            Object.keys(param).forEach((value, key) => {
                                formData.append(value ,param[value] );
                            })
    
                            _this.api.getMakeSale(  formData ).then(res => {
                                console.log(res);
                                _this.$message.success('提交成功');
                                _this.$router.push('loginMenu');
                            })

                        }

                    }
                })

            },

            // 获取印模列表 
            getYinMu() {
                
                let param = new FormData();
                param.append('token', this.$global.token);

                let _this = this;
                // 【API请求】-----获取印模列表
                _this.api.getStampList(param).then(res => {
                    _this.options = res.data;
                    console.log(_this.options);
                })
            },
            getStampId() {
                for (let i = 0; i < this.options.length; i++) {
                    if (this.dataForm.stampId == this.options[i].id) {
                        this.stampImg = this.options[i].stampTemplateBase64
                    }
                }
            },
             
            

            isLookXieYi() {
                if (this.checked && this.regChecked || this.regChecked) {
                    return true
                } else {
                    this.$message.error('请先阅读协议');
                    return false
                }
            },
            getUkeyMes() {
                let _this = this;
                let param = new FormData();
                param.append('type', 3);
                _this.api.registText(param).then(res => {
                    _this.content = res.data.content;
                })
            },
            handlCheckZhan() {
                this.isZhanKai = !this.isZhanKai;
            },

            handlJump() {

                let _this = this; 
                let param = new FormData();
                param.append('type',  4 );
                _this.api.registText(param).then(res => {
                    _this.agreementContent = res.data.content;
                    _this.agreementDialogVisible  = true ;
                })
                
            },
            
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';


    /deep/ .el-checkbox:last-of-type {
        display: @flex;
        align-items: center;
        margin: 0 20px;
    }

    .addSeal {
        width: @a;
        height: auto;
        margin-left: 4%;

        .per_title {
            width: @a;
            height: 40px;
            display: @flex;
            align-items: center;

            .title {
                width: auto;
                height: auto;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: bolder;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
            }

            .btn {
                width: 120px;
                height: 40px;
                margin-left: 33px;
                line-height: 40px;
                text-align: center;
                letter-spacing: 1px;
                color: #ffffff;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                cursor: pointer;
            }

            span {
                width: auto;
                height: auto;
                margin-left: 17px;
                font-family: MicrosoftYaHei;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #e10000;
            }

            .lookBtn {
                width: 120px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-color: #fff;
                border: solid 1px #aaaaaa;
                letter-spacing: 1px;
                color: #333333;
                margin-left: 15px;
                cursor: pointer;
            }
        }

        .account {
            width: 753px;
            height: auto;
            display: @flex;
            align-items: center;
            margin-top: 40px;

            .acte {
                width: 210px;
                height: auto;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: bolder;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
                text-align: end;
            }

            .iuten {
                width: 220px;
                height: auto;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: bolder;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
                text-align: end;
            }

            .key {
                width: 280px;
                height: 25px;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: bolder;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
            }

            .input {
                width: 520px;
                height: 60px;
                position: relative;

                /deep/ .el-input__inner {
                    width: 520px;
                    height: 60px;
                }

                .btn {
                    width: 150px;
                    height: 60px;
                    line-height: 60px;
                    text-align: center;
                    cursor: pointer;
                    background-color: #f5f5f5;
                    border: solid 1px #aaaaaa;
                    letter-spacing: 1px;
                    color: #333333;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                }
            }
        }

        .show {
            width: @a;
            height: 200px;
            overflow: hidden;
            margin-left: 180px;
            zoom: 1;

            .img {
                width: 250px;
                height: 170px;
                background-color: #f2f2f2;
                border: solid 1px #aaaaaa;
                margin-left: 33px;
                margin-top: 30px;
                float: left;

                img {
                    width: @a;
                    height: @a;
                    object-fit: cover;
                }
            }
        }

        .perBtn {
            width: @a;
            height: 80px;
            margin-top: 30px;

            .btn {
                width: 520px;
                height: 80px;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                font-size: 24px;
                letter-spacing: 1px;
                color: #ffffff;
                line-height: 80px;
                text-align: center;
                margin-left: 210px;
                cursor: pointer;
            }
        }

        .bus {
            width: @a;
            height: auto;
            margin-top: 30px;

            .action {
                width: @a;
                height: auto;
                display: @flex;

                .select {
                    width: auto;
                    height: auto;
                }

                .sempetImg {
                    margin: 30px 0;
                }

                span {
                    width: 210px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: bolder;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #333333;
                    text-align: end;
                }

                img {
                    width: 170px;
                    height: 170px;
                    cursor: pointer;
                }
            }

        }


        .Ukey {
            width: @a;
            height: auto;
            display: @flex;
            margin-top: 100px;

            span {
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
            }

            .look {
                font-family: MicrosoftYaHei;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #eb0000;
                margin-left: 20px;
            }

            .text {
                width: auto;
                height: 23px;
                font-family: MicrosoftYaHei-Bold;
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;

                span {
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 20px;
                    font-weight: normal;
                    letter-spacing: 1px;
                    color: #1e6eee;
                    margin-left: 20px;
                    cursor: pointer;
                }
            }
        }

        .regist {
            width: @a;
            height: auto;
            margin-top: 15px;
            display: @flex;
            margin-left: 235px;

            font-family: MicrosoftYaHei;
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;

            span {
                font-family: MicrosoftYaHei;
                font-size: 18px;
                font-weight: normal;
                letter-spacing: 1px;
                color: #1e6fee;
                margin-left: 10px;
            }
        }





    }
</style>



// WEBPACK FOOTER //
// src/components/page/seal/addOnePerSeal.vue